import { render } from "./ImageSlot.vue?vue&type=template&id=0640a81c&scoped=true"
import script from "./ImageSlot.vue?vue&type=script&lang=js"
export * from "./ImageSlot.vue?vue&type=script&lang=js"

import "./ImageSlot.vue?vue&type=style&index=0&id=0640a81c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0640a81c"]])

export default __exports__